// @ts-nocheck
import * as types from '../types';

const initialState = {
    depositsWithdrawals: {
        reports: [],
    },
    withdrawalAutoprocessingRules: {
        list: [],
        current: null,
        drawer: {
            type: '',
            isVisible: false,
        },
    },
    paymentMethods: {
        list: [],
        drawer: {
            data: null,
            isVisible: false,
        }
    },
};

const payment = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.DEPOSITS_WITHDRAWALS_REPORTS_CLEARED: {
            return {
                ...state,
                depositsWithdrawals: initialState.depositsWithdrawals,
            };
        }
        case types.DEPOSITS_WITHDRAWALS_REPORTS_CHANGED: {
            return {
                ...state,
                depositsWithdrawals: {
                    ...state.depositsWithdrawals,
                    ...payload,
                },
            };
        }
        case types.WITHDRAWAL_AUTOPROCESSING_LIST_CHANGED: {
            return {
                ...state,
                withdrawalAutoprocessingRules: {
                    ...state.withdrawalAutoprocessingRules,
                    list: payload,
                },
            };
        }
        case types.WITHDRAWAL_AUTOPROCESSING_CURRENT_CHANGED: {
            return {
                ...state,
                withdrawalAutoprocessingRules: {
                    ...state.withdrawalAutoprocessingRules,
                    current: payload,
                },
            };
        }
        case types.WITHDRAWAL_AUTOPROCESSING_DRAWER_CHANGED: {
            return {
                ...state,
                withdrawalAutoprocessingRules: {
                    ...state.withdrawalAutoprocessingRules,
                    drawer: payload,
                },
            };
        }
        case types.PAYMENT_METHODS_LIST_CHANGED: {
            return {
                ...state,
                paymentMethods: {
                    ...state.paymentMethods,
                    list: payload,
                },
            };
        }
        case types.PAYMENT_METHODS_DRAWER_PROPS_CHANGED: {
            return {
                ...state,
                paymentMethods: {
                    ...state.paymentMethods,
                    drawer: payload,
                },
            };
        }
        default:
            return state;
    }
};

export default payment;
